import styled from 'styled-components';

export const Container = styled.div`
  background-color: #fff;
  padding: 72px 0 0 0;
  position: fixed;
  top: 0;
  bottom: calc(100vh - var(--height-full));
  z-index: 25;
`;
